module.exports = __webpack_public_path__ + "img/wxVideoAccount.726a23e5.png";